import React from 'react';
import PageHeader from '../components/PageHeader';
import AdminPanel from '../components/ui/AdminPanel';
import './AdminDashboardPage.css';

const AdminDashboardPage: React.FC = () => {
  return (
    <div className="admin-dashboard-page">
      <PageHeader />
      <main className="admin-dashboard-page-content">
        <AdminPanel />
      </main>
    </div>
  );
};

export default AdminDashboardPage;
